import Vue from 'vue'

Vue.filter('fileSizeDisplay', function (bytes) {
    var thresh = 1024;
    if(Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }
    var units = ['kB','MB','GB','TB','PB','EB','ZB','YB'];
    var u = -1;
    do {
        bytes /= thresh;
        ++u;
    } while(Math.abs(bytes) >= thresh && u < units.length - 1);
    return bytes.toFixed(1)+' '+units[u];
});

Vue.filter('fileIcon', function (mimeType) {
    switch (mimeType) {
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return 'file-word';
        case 'application/pdf':
            return 'file-pdf';
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return 'file-excel';
        case 'application/zip':
            return 'file-archive';
        case 'image/gif':
        case 'image/jpeg':
        case 'image/png':
            return 'file-image';
        default:
            return 'file';
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/filters/files.js